module.exports = __webpack_public_path__ + "img/02_christina-wocintechchat.e04899e6.jpg";